import Clasicos from '../global/img/litros/Clasicos.jpg';
import GINTonic from '../global/img/litros/GINTonic.jpg';
import Margaritas from '../global/img/litros/Margaritas.jpg';
import Mojitos from '../global/img/litros/Mojitos.jpg';
import Mezcal from '../global/img/litros/Mezcal.jpg';

export const carta_litros = [
  {
    tipo: 'litros_bambinos',
    nombre: 'Gin Tonic',
    img: GINTonic,
  },
  {
    tipo: 'litros_bambinos',
    nombre: 'Mojitos',
    img: Mojitos,
  },
  {
    tipo: 'litros_bambinos',
    nombre: 'Margaritas',
    img: Margaritas,
  },
  {
    tipo: 'litros_bambinos',
    nombre: 'Mezcal',
    img: Mezcal,
  },
  {
    tipo: 'litros_bambinos',
    nombre: 'Clásicos',
    img: Clasicos,
  },
];
